export const fridaySermons = [
  {
    date: '2026-10-23',
    title: '[얼바인중앙침례교회 금요성령기도회] 성령이 충만하면 거룩함을 사모하게 됩니다 | 사도행전 19:18-20',
    videoId: 'cS1LvKRZs6Q'
  },
  {
    date: '2026-10-16',
    title: '[얼바인중앙침례교회 금요성령기도회] 성령이 충만하면 말씀이 살아 움직입니다. | 사도행전 2:36-42',
    videoId: 'Oyx6FCp_7Yo'
  },
  {
    date: '2026-10-09',
    title: '[얼바인중앙침례교회 금요성령기도회] 성령이 충만하면.. 예수님이 크게보입니다 | 요한복음 16:13-14',
    videoId: '55jIZU-vJmU'
  },
  {
    date: '2026-10-02',
    title: '[얼바인중앙침례교회 금요성령기도회] 말씀을 끝까지 붙드는 사람 | 요한계시록 22:6-7',
    videoId: 'kRxDJLqpR88'
  },
  {
    date: '2026-09-25',
    title: '[얼바인중앙침례교회 금요성령기도회] 말씀을 전하는 사람 | 디모데후서 4:2',
    videoId: '8DyvBETvBb4'
  },
  {
    date: '2026-09-18',
    title: '[얼바인중앙침례교회 금요성령기도회] 말씀으로 거룩해지는 사람 | 요한복음 17 :17',
    videoId: 'Wp1s9Gjq0RU'
  },
  {
    date: '2026-09-11',
    title: '[얼바인중앙침례교회 금요성령기도회] 말씀으로 기도하는 사람 | 요한복음 15 :7',
    videoId: 'x37Cm4WSvog'
  },
  {
    date: '2026-09-04',
    title: '[얼바인중앙침례교회 금요성령기도회] 말씀으로 싸우는 사람 | 마태복음 4 : 4',
    videoId: 'wg1AxEBsVOI'
  },
  {
    date: '2026-08-28',
    title: '[얼바인중앙침례교회 금요성령기도회] 말씀을 묵상하는 사람 | 시편 1 : 1-3',
    videoId: 'ufbcAtf1KLk'
  },
  {
    date: '2026-08-21',
    title: '[얼바인중앙침례교회 금요성령기도회] 말씀을 사랑하는 사람 | 시편 119 : 97-104',
    videoId: 'h4YEC5oTmXo'
  },
  {
    date: '2026-08-14',
    title: '[얼바인중앙침례교회 금요성령기도회] 말씀을 믿는 사람 | 히브리서 4:1-2',
    videoId: 'axIOr5quJUo'
  },
  {
    date: '2026-08-07',
    title: '[얼바인중앙침례교회 금요성령기도회] 말씀을 듣는 사람 | 야고보서 1:22-25',
    videoId: 'qBy_xdogcLo'
  },
  {
    date: '2026-07-31',
    title: '[얼바인중앙침례교회 금요성령기도회] 내가 다시 오겠다고 약속하신 예수님 | 요한복음 14:1-3',
    videoId: 'SCn5kEgWK6k'
  },
  {
    date: '2026-07-24',
    title: '[얼바인중앙침례교회 금요성령기도회] 결코 너를 떠나지 않겠다고 약속하신 하나님 | 히브리서 13:5',
    videoId: 'pulrObjo2YY'
  },
  {
    date: '2026-07-17',
    title: '[얼바인중앙침례교회 금요성령기도회] 평안을 주시겠다고 약속하신 하나님 | 요한복음 14:27',
    videoId: 'QGVcY_bRI1g'
  },
  {
    date: '2026-07-10',
    title: '[얼바인중앙침례교회 금요성령기도회] 지혜를 구하면 후히 주시겠다고 약속하신 하나님 | 야고보서 1:5',
    videoId: 'cD8sVAFZ0Cg'
  },
  {
    date: '2026-07-03',
    title: '[얼바인중앙침례교회 금요성령기도회] 너희를 쉬게 하겠다고 말씀하신 하나님 | 마태복음 11:28-30',
    videoId: 'ADDxsdYHHtg'
  },
  {
    date: '2026-06-26',
    title: '[얼바인중앙침례교회 금요성령기도회] 모든 쓸 것을 채우시겠다고 말씀하신 하나님 | 빌립보서 4:19',
    videoId: 'LLKqSTUkmjY'
  },
  {
    date: '2026-06-19',
    title: '[얼바인중앙침례교회 금요성령기도회] 모든 것이 합력하여 선을 이룬다고 말씀하신 하나님 | 로마서 5:28',
    videoId: '4UIiHotTXJE'
  },
  {
    date: '2026-06-12',
    title: '[얼바인중앙침례교회 금요성령기도회] 항상 기뻐하라, 쉬지말고 기도하라, 범사에 감사하라 말씀하신 하나님 | 데살로니가전서 5:16-18',
    videoId: 'ZWUWx5WCOBw'
  },
  {
    date: '2026-06-05',
    title: '[얼바인중앙침례교회 금요성령기도회] 내 은혜가 네게 족하다고 말씀하신 하나님 | 고런도후서 12:9',
    videoId: 'wSvVVjwmBvE'
  },
  {
    date: '2026-05-29',
    title: '[얼바인중앙침례교회 금요성령기도회] 함께 하시겠다고 말씀하신 하나님 | 출애굽기 33:14-15, 여호수아 1:9',
    videoId: 'V0E-VDRnLHc'
  },
  {
    date: '2026-05-22',
    title: '[얼바인중앙침례교회 금요성령기도회] 그 말씀은 지금도 나를 향하고 있습니다 | 히브리서 4:12-13',
    videoId: 'rjlyD0vgaes'
  },
  {
    date: '2026-05-15',
    title: '[얼바인중앙침례교회 금요성령기도회] 말씀으로 내 삶을 해석하라 | 창새기  50:20',
    videoId: 'dMYnKgtJX8I'
  },
  {
    date: '2026-05-08',
    title: '[얼바인중앙침례교회 금요성령기도회] 말씀은 기준이 아니라 주인입니다 | 골로새서 3:16-17',
    videoId: 'Xu3r8C46gvk'
  },
  {
    date: '2026-05-01',
    title: '[얼바인중앙침례교회 금요성령기도회] 순종을 이끄는 말씀 | 누가복음 5:3-11',
    videoId: 'EmebqyEUF18'
  },
  {
    date: '2026-04-24',
    title: '[얼바인중앙침례교회 금요성령기도회] 고난 속에서 우리를 살리는 말씀 | 시편  119:49-50',
    videoId: 'z3G-OhIPPrI'
  },
  {
    date: '2026-04-17',
    title: '[얼바인중앙침례교회 금요성령기도회] 말씀이 이끄는 삶, 말씀이 이끄는 기도 | 요한복음 15:7',
    videoId: 'Ynxgm4WVgPA'
  },
  {
    date: '2026-04-10',
    title: '[얼바인중앙침례교회 금요성령기도회] 말씀으로 시작된 생명, 말씀으로 자라는 생명 | 베드로전서 1:23',
    videoId: '9RSEt2a6XFc'
  },
  {
    date: '2026-04-03',
    title: '[얼바인중앙침례교회 금요성령기도회] 십자가 앞에서 갈리는 두 강도 | 누가복음 23:39-43',
    videoId: 'yN1mdJyUdH0'
  },
  {
    date: '2026-03-27',
    title: '[얼바인중앙침례교회 금요성령기도회] 말씀은 생명입니다. | 요한복음 1:1-4, 14',
    videoId: 'eZXCFcAWsNo'
  },
  {
    date: '2026-03-20',
    title: '[얼바인중앙침례교회 금요성령기도회] 하나님은 말씀으로 시작하신다 | 창세기 1:3',
    videoId: 'muCV5fDH48w'
  },
  {
    date: '2026-03-13',
    title: '[얼바인중앙침례교회 금요성령기도회] 기도응답의 최종 목적 | 요한복음 14:13',
    videoId: 'CPAzLwGQYg4'
  },
  {
    date: '2026-03-06',
    title: '[얼바인중앙침례교회 금요성령기도회] 주의 뜻이 교회 가운데 이루어지게 하소서 | 에베소서 1:17-19',
    videoId: 'uDxcSIwK0Js'
  },
  {
    date: '2026-02-27',
    title: '[얼바인중앙침례교회 금요성령기도회] 하나님의 뜻이 이미 정해져 있을 때의 기도 | 사도행전 4:23 - 31',
    videoId: 'NnzAovOoYjo'
  },
  {
    date: '2026-02-20',
    title: '[얼바인중앙침례교회 금요성령기도회] 하나님의 뜻을 분별하는 기도 | 시편 119:105',
    videoId: '3Uu_SjgXslU'
  },
  {
    date: '2026-02-06',
    title: '[얼바인중앙침례교회 금요성령기도회]  하나님을 내편으로 만들려는 기도 | 야고보서 4:1-3',
    videoId: 'oPp4J9s-VKY'
  },
  {
    date: '2026-01-30',
    title: '[얼바인중앙침례교회 금요성령기도회]  하나님의 뜻이 늦어 보일 때 | 하박국 2:1-4',
    videoId: '2dmbcusD9aY'
  },
  {
    date: '2026-01-23',
    title: '[얼바인중앙침례교회 금요성령기도회]  하나님의 뜻이 고난일까 두려울 때 | 마태복음 26: 39-45',
    videoId: 'mr1hVzeyCc0'
  },
  {
    date: '2026-01-16',
    title: '[얼바인중앙침례교회 금요성령기도회] 하나님의 뜻을 알지 못할 때 드리는 기도 | 로마서 12:1-2',
    videoId: 'PQ2YY-7M7Uw'
  },
  {
    date: '2026-01-09',
    title: '[얼바인중앙침례교회 금요성령기도회]  내 뜻을 내려놓는 것에서 시작 | 마태복음 6:9-10',
    videoId: 'QxZx3Y5ZyyA'
  },
  {
    date: '2026-01-02',
    title: '[얼바인중앙침례교회 금요성령기도회]  한해를 시작하며, 하나님의 얼굴을 구하는 기도 | 시편 27:8',
    videoId: 'umlQc-2-6Iw'
  },
  {
    date: '2025-12-26',
    title: '[얼바인중앙침례교회 금요성령기도회 설교]  한해를 마무리 하는 기도 7. 미자막에서 시작을 바라보는 기도 (이사야 43: 18-21) / 2025.12.26 pm 7:30',
    videoId: 'iFEvTqgSf94'
  },
  {
    date: '2025-12-19',
    title: '[얼바인중앙침례교회 금요성령기도회 설교]  한해를 마무리 하는 기도 6. 믿음의 눈을 위한  기도 (고린도후서 4: 16-18) / 2025.12.19 pm 7:30',
    videoId: 'wWqm8VhLzLw'
  },
  {
    date: '2025-12-12',
    title: '[얼바인중앙침례교회 금요성령기도회 설교]  한해를 마무리 하는 기도 5. 믿음의 공동체를 위한 기도 (에베소서 3:14-21) / 2025.12.12 pm 7:30',
    videoId: 'A6TRH-iVVlI'
  },
  {
    date: '2025-12-05',
    title: '[얼바인중앙침례교회 금요성령기도회 설교]  한해를 마무리 하는 기도 4. 소망의 기도 (예레미야 29:11) / 2025.12.5 pm 7:30',
    videoId: 'ZjW24EUq50A'
  },
  {
    date: '2025-11-28',
    title: '[얼바인중앙침례교회 금요성령기도회 설교]  한해를 마무리 하는 기도 3. 감사로 아뢰라 (빌립보서 4:6-7) / 2025.11.28 pm 7:30',
    videoId: 'qu7pSMCFg3o'
  },
  {
    date: '2025-11-21',
    title: '[얼바인중앙침례교회 금요성령기도회 설교]  한해를 마무리 하는 기도 2. 돌이키소서 (시편 51:10-12) / 2025.11.21 pm 7:30',
    videoId: 'pO3a82a4Q6Y'
  },
  {
    date: '2025-11-14',
    title: '[얼바인중앙침례교회 금요성령기도회 설교]  한해를 마무리 하는 기도 1. 에벤에셀 (사무엘상 7:12) / 2025.11.14 pm 7:30',
    videoId: 'xjy7SHvc8GQ'
  },
  {
    date: '2025-11-07',
    title: '[얼바인중앙침례교회 금요성령기도회 설교]  주님의 오심을 준비하는  기도 (말라기 4:1-6) / 2025.11.7 pm 7:30',
    videoId: '-EYQbM0mTF8'
  },
  {
    date: '2025-10-31',
    title: '[얼바인중앙침례교회 금요성령기도회 설교]  남은 자의 기도 (말라기 3:16-18) / 2025.10.31 pm 7:30',
    videoId: 'JeR4F507CL8'
  },
  {
    date: '2025-10-24',
    title: '[얼바인중앙침례교회 금요성령기도회 설교]  금식? 기도? (스가랴 7:1-12) / 2025.10.24 pm 7:30',
    videoId: 'zxo_FpYIczA'
  },
  {
    date: '2025-10-17',
    title: '[얼바인중앙침례교회 금요성령기도회 설교]  하나님, 언제까지 입니까?   (스가랴 1:12-17) / 2025.10.17 pm 7:30',
    videoId: 'HwyobT327ro'
  },
  {
    date: '2025-10-10',
    title: '[얼바인중앙침례교회 금요성령기도회 설교]  비교와 낙심의 자리에서 마음을 지키는 기도  (학개 2:1-9) / 2025.10.10 pm 7:30',
    videoId: '3vZDHzrJizc'
  },
  {
    date: '2025-10-03',
    title: '[얼바인중앙침례교회 금요성령기도회 설교]  마음을 감동시킨 순종의 기도  (학개 1:12-14) / 2025.10.03 pm 7:30',
    videoId: '1WEwqNXy5sw'
  },
  {
    date: '2025-09-26',
    title: '[얼바인중앙침례교회 금요성령기도회 설교]  남은 자의 기도  (스바냐 3:9-13) / 2025.9.26 pm 7:30',
    videoId: 'BD4eSBXMQ5k'
  },
  {
    date: '2025-09-19',
    title: '[얼바인중앙침례교회 금요성령기도회 설교]  진노중에도 긍휼을 구하는 기도  (하박국 3:1-2) / 2025.9.19 pm 7:30',
    videoId: '7sLSI3NRr0A'
  },
  {
    date: '2025-09-12',
    title: '[얼바인중앙침례교회 금요성령기도회 설교]  하나님의 침묵에 대한 기도 (하박국 1:1-5) / 2025.9.12 pm 7:30',
    videoId: '9Md0gAGu_Bo'
  },
  {
    date: '2025-09-05',
    title: '[얼바인중앙침례교회 금요성령기도회 설교]  닫힌 문 뒤에서 드린 여는 기도 (다니엘 6:10-17, 23) / 2025.9.5 pm 7:30',
    videoId: 'VHLyzrS6XRA'
  },
  {
    date: '2025-08-29',
    title: '[얼바인중앙침례교회 금요성령기도회 설교]  기도가 열어주는 하나님의 지혜 (다니엘 2:17-23) / 2025.8.29 pm 7:30',
    videoId: 'jaxD4aH-Fwo'
  },
  {
    date: '2025-08-22',
    title: '[얼바인중앙침례교회 금요성령기도회 설교]  죽으면 죽으리이다 (에스더 4:13-17, 5:1-3절) / 2025.8.22 pm 7:30',
    videoId: 'iFBsror7wew'
  },
  {
    date: '2025-08-15',
    title: '[얼바인중앙침례교회 금요성령기도회 설교] 무너진 성벽을 위한 회복의 기도  (느헤미야 1장 1-11절) / 2025.8.15 pm 7:30',
    videoId: 'mSqG_As95e4'
  },
  {
    date: '2025-08-08',
    title: '[얼바인중앙침례교회 금요성령기도회 설교] 내 뜻과 하나님 뜻 사이에서 드리는 기도  (열왕기하 20장 1-6절) / 2025.8.8 pm 7:30',
    videoId: 'Dy77Sq8dbx8'
  },
  {
    date: '2025-08-01',
    title: '[얼바인중앙침례교회 금요성령기도회 설교] 주의 이름을 위한 기도  (열왕기하 19장 14-20절) / 2025.8.1 pm 7:30',
    videoId: 'DCl1TqS7z3I'
  },
  {
    date: '2025-07-25',
    title: '[얼바인중앙침례교회 금요성령기도회 설교] 가뭄을 끝낸 일곱번의 기도 (열왕기상 18장 41-46절) / 2025.7.25 pm 7:30',
    videoId: 'tcNitm_Rz0E'
  },
  {
    date: '2025-07-18',
    title: '[얼바인중앙침례교회 금요성령기도회 설교] 불이 아닌 뜻을 위한 기도 (열왕기상 18장 36-39절) / 2025.7.18 pm 7:30',
    videoId: 'VEUNki5t_lU'
  },
  {
    date: '2025-07-11',
    title: '[얼바인중앙침례교회 금요성령기도회 설교] 하나님의 말씀을 드러내는 기도  (열왕기상 17장 17-24절) / 2025.7.11 pm 7:30',
    videoId: '1N7nf-gixjg'
  },
  {
    date: '2025-07-04',
    title: '[얼바인중앙침례교회 금요성령기도회 설교] 좋은 기도 그리고 중요한 것  (열왕기상 3장 5-15절) / 2025.7.4 pm 7:30',
    videoId: 'bpZY201bGM4'
  },
  {
    date: '2025-06-13',
    title: '[IJBC 금요성령기도회 설교] 고난 중의 기도로 뜻을 이루시는 하나님  (사무엘상 1장 9-18절) / 2025.6.13 pm 8:00',
    videoId: 'DUUWxa6sooY'
  },
  {
    date: '2025-06-06',
    title: '[얼바인중앙침레교회 금요성령기도회 설교] 순종에서 나오는 기도  (여호수아 10장 11-14절) / 2025.6.6 pm 8:00',
    videoId: 'kO_W9VClh2k'
  },
  {
    date: '2025-05-30',
    title: '[IJBC 금요성령기도회 설교] 하나님의 일, 기도로 시작되고 기도로 완성됩니다.  (여호수아 5장 13-15절) / 2025.5.30 pm 8:00',
    videoId: '-uB6mN3wuLk'
  },
  {
    date: '2025-05-23',
    title: '[IJBC 금요성령기도회 설교] 홍해 앞에서의 기도  (출애굽기 14장 10-18,30-31절) / 2025.5.23 pm 8:00',
    videoId: '4fiXMXaJaMg'
  },
  {
    date: '2025-05-16',
    title: '[IJBC 금요성령기도회 설교] 하나님의 역사를 이루는 기도  (출애굽기 21장 7-17절) / 2025.5.16 pm 8:00',
    videoId: 'AKKFXYfqG8g'
  },
  {
    date: '2025-05-09',
    title: '[IJBC 금요성령기도회 설교] 기도에 대한 마지막 가르침.  (누기복음 21장 36절) / 2025.5.9 pm 8:00',
    videoId: 'Rc892Wmt6c0'
  },
  {
    date: '2025-05-02',
    title: '[IJBC 금요성령기도회 설교] 참된 기도는 배우는 것입니다.  (누기복음 18장 1-14절) / 2025.5.2 pm 8:00',
    videoId: '6V5lb6lf6Jk'
  },
  {
    date: '2025-04-25',
    title: '[IJBC 금요성령기도회 설교] 기도의 최고의 응답  (누기복음 11장 13절) / 2025.4.25 pm 8:00',
    videoId: 'Zr_JzWA2myY'
  },
  {
    date: '2025-04-11',
    title: '[IJBC 금요성령기도회 설교]  기도를 어떻게 마쳐야 하나?  (마태복음 6장 13절) / 2025.4.11 pm 8:00',
    videoId: 'ap2nAvHIL4w'
  },
  {
    date: '2025-04-04',
    title: '[IJBC 금요성령기도회 설교]  다만 악에서 구하소서  (마태복음 6장 13절) / 2025.4.4 pm 8:00',
    videoId: 'zOtrl2SPuzY'
  },
  {
    date: '2025-03-28',
    title: '[IJBC 금요성령기도회 설교]  시험에 들게 하지 마옵소서  (마태복음 6장 13절) / 2025.3.28 pm 8:00',
    videoId: 'IAUyvrUKW1U'
  },
  {
    date: '2025-03-07',
    title: '[IJBC 금요성령기도회 설교]  용서가 있는 곳에 은혜가 (마태복음 6장 12절) / 2025.3.7 pm 8:00',
    videoId: 'D3ZnzOr9ptA'
  },
  {
    date: '2025-03-07',
    title: '[IJBC 금요성령기도회 설교]  오늘 우리에게 일용할 양식을 위해 구하라고 하시는 이유 (마태복음 6장 11절) / 2025.3.7 pm 8:00',
    videoId: 'sAnljznBnfc'
  },
  {
    date: '2025-03-07',
    title: '[IJBC 금요성령기도회 설교] 가장 먼저 기도해야 할 하나님의 나라 (마태복음 6장 10절) / 2025.3.7 pm 8:00',
    videoId: 'RRiUY3ibUZs'
  },
  {
    date: '2025-02-28',
    title: '[IJBC 금요성령기도회 설교] 하늘에 계신 우리 아버지여 (누가복음 6장 9절) / 2025.2.28 pm 8:00',
    videoId: 'Fjqp4FGFDPc'
  },
  {
    date: '2025-02-21',
    title: '[IJBC 금요성령기도회 설교] 기도에 대한 믿음 (누가복음 11장 1절) / 2025.2.21 pm 8:00',
    videoId: 'KKqmpWhYxW0'
  },
  {
    date: '2025-02-14',
    title: '[IJBC 금요성령기도회 설교] 예수님의 기도와 베드로의 신앙고백  (누가복음 9장 18-26절) / 2025.2.14 pm 8:00',
    videoId: 'N4MuI3rjDmk'
  },
  {
    date: '2025-02-07',
    title: '[IJBC 금요성령기도회 설교] 변화산에서의 기도 (누가복음 9장 28-36절) / 2025.2.7 pm 8:00',
    videoId: 'QUDUXHDcHF8'
  },
  {
    date: '2025-01-24',
    title: '[IJBC 금요성령기도회 설교] 중요한 선택 앞에서 하신 기도 (누가복음 6장 11-16절) / 2025.1.24 pm 8:00',
    videoId: 'YgVnXjjplg4'
  },
  {
    date: '2025-01-10',
    title: '[IJBC 금요성령기도회 설교] 숨을 쉴 수 있다면 찬양하라 (시편 150편) / 2025.1.10 pm 8:00',
    videoId: 'TakSdEZWpPg'
  },
  {
    date: '2025-01-07',
    title: '[IJBC 금요성령기도회 설교] 하을이 열리는 기도 (누가복음 3장 21-22절) / 2025.1.7 pm 8:00',
    videoId: 'FdWCbt368aM'
  },
  {
    date: '2025-01-03',
    title: '[IJBC 금요성령기도회] 새해에 새 노래로 찬양하라 (시편 149편) / 2025.1.3 pm 8:00',
    videoId: 'o1ShWC7uIX8'
  },
  {
    date: '2024-12-27',
    title: '[IJBC 금요성령기도회] 폐하지 못 할 하나님의 명령: 섭리 (시편 148편 1-14절) / 2024.12.27 pm 8:00',
    videoId: 'WmKBnc8aecU'
  },
  {
    date: '2024-12-20',
    title: '[IJBC 금요성령기도회] 하나님이 기뻐하시는 사람 (시편 147편 6-11절) / 2024.12.20 pm 8:00',
    videoId: 'w5IxKgL8Wf0'
  },
  {
    date: '2024-12-13',
    title: '[IJBC 금요성령기도회] 누가 정말로 지혜로운가? (시편 146편 1-10절) / 2024.12.13 pm 8:00',
    videoId: '2QyOktjYMJA'
  },
  {
    date: '2024-12-06',
    title: '[IJBC 금요성령기도회] 하나님을 경험하고 하나님을 찬양하라 (시편 145편 1-7절) / 2024.12.06 pm 8:00',
    videoId: 'jhOVT4YBTCk'
  },
  {
    date: '2024-11-29',
    title: '[IJBC 금요성령기도회] 전쟁 중에도 복을 누리는 성도들 (시편 144편) / 2024.11.29 pm 8:00',
    videoId: 'jqYgl2GjOX4'
  },
  {
    date: '2024-11-22',
    title: '[얼바인중앙침례교회 금요찬양기도집회] 영혼의 고통에서 나를 건지소서 (시편 143편 1-12) / 정성택 목사 / 2024.11.22. PM 8:00 #성령집회 #시편강해',
    videoId: 'vPgVYM_hbME'
  },
  {
    date: '2024-11-15',
    title: '[얼바인중앙침례교회 금요찬양기도집회] 인생의 동굴 속에 있을 때 (시편 142편 1-7) / 정성택 목사 / 2024.11.15. PM 8:00 #성령집회 #시편강해',
    videoId: '4UNLUxAeFic'
  },
  {
    date: '2024-11-01',
    title: '[얼바인중앙침례교회 금요찬양기도집회]  성도의 계속되는 기도 (시편 141편 1-10) / 정성택 목사 / 2024.11.01. PM 8:00 #성령집회 #시편강해',
    videoId: 'IlicaI2-5Cc'
  },
  {
    date: '2024-10-25',
    title: '[얼바인중앙침례교회 금요찬양기도집회] 악인의 손에 빠지지 않게 하소서 (시편 140편 1-5, 13절) / 정성택 목사 / 2024.10.25. PM 8:00 #성령집회 #시편강해',
    videoId: 'bfPlTjx82ZM'
  },
  {
    date: '2024-10-11',
    title: '[얼바인중앙침례교회 금요찬양기도집회] 나를 인도하소서 (시편 139편 23-24절) / 정성택 목사 / 2024.10.11. PM 8:00 #성령집회 #시편강해',
    videoId: 'leXnmPUrf9M'
  },
  {
    date: '2024-10-11',
    title: '[얼바인중앙침례교회 금요찬양기도집회] 성도를 위한 최고의 위로 (시편 138편 1-8절) / 정성택 목사 / 2024.10.11. PM 8:00 #성령집회 #시편강해',
    videoId: 'Ww7RqVEsFWE'
  },
  {
    date: '2024-09-20',
    title: '[얼바인중앙침례교회 금요찬양기도집회] 바벨론과 같은 세상에서  (시편 137편 1-9절) / 정성택 목사 / 2024.09.20. PM 8:00 #성령집회 #시편강해',
    videoId: 'B3IBwhDITac'
  },
  {
    date: '2024-09-13',
    title: '[얼바인중앙침례교회 금요찬양기도집회] 감사를 잘하려면 (시편 136편 1-26절) / 정성택 목사 / 2024.09.13. PM 8:00 #성령집회 #시편강해',
    videoId: 'lz8Mu9lwm3k'
  },
  {
    date: '2024-08-30',
    title: '[얼바인중앙침례교회 금요찬양기도집회] 하나님을 찬양하는 이유 (시편 135편 1-21절) / 정성택 목사 / 2024.08.30. PM 8:00 #성령집회 #시편강해',
    videoId: '2Vp8gvXzOcg'
  },
  {
    date: '2024-08-23',
    title: '[얼바인중앙침례교회 금요찬양기도집회] 선하고 아름다운 것 (시편 133편 1-3절) / 정성택 목사 / 2024.08.23. PM 8:00 #성령집회 #시편강해',
    videoId: 'fCXYbRswMWo'
  },
  {
    date: '2024-07-26',
    title: '[얼바인중앙침례교회 금요찬양기도집회]  죄를 고백하는 은혜(시편 130편 1-8절) / 정성택 목사 / 2024.07.26. PM 8:00 #성령집회 #시편강해',
    videoId: 'lehs4lRVTEo'
  },
  {
    date: '2024-06-28',
    title: '[얼바인중앙침례교회 금요찬양기도집회]  악인이 주의 백성을 이기지 못하리라.(시편 129편 1-8절) / 정성택 목사 / 2024.06.28. PM 8:00 #성령집회 #시편강해',
    videoId: '--bixRC4-_Y'
  },
  {
    date: '2024-06-28',
    title: '[얼바인중앙침례교회 금요찬양기도집회]  주의 길을 가는 자가 복이 있습니다.(시편 128편 1-6절) / 정성택 목사 / 2024.06.28. PM 8:00 #성령집회 #시편강해',
    videoId: 'LXP8vShCGOg'
  },
  {
    date: '2024-06-28',
    title: '[얼바인중앙침례교회 금요찬양기도집회]  오직 주님만을 의지해야 합니다.(시편 127편 1-5절) / 정성택 목사 / 2024.06.28. PM 8:00 #성령집회 #시편강해',
    videoId: 'RLKaj9QYPT8'
  },
  {
    date: '2024-05-31',
    title: '[얼바인중앙침례교회 금요찬양기도집회] 울어야 할 때에는 울 수 있어야 합니다 (시편 126편 1-6절) / 정성택 목사 / 2024.05.31. PM 8:00 #성령집회 #시편강해',
    videoId: 'xv-6Oga320E'
  },
  {
    date: '2024-05-31',
    title: '[얼바인중앙침례교회 금요찬양기도집회] 흔들리지 않는 자  (시편 125편 1-5절) / 정성택 목사 / 2024.05.31. PM 8:00 #성령집회 #시편강해',
    videoId: '_q8jL-0m-rc'
  },
  {
    date: '2024-05-31',
    title: '[얼바인중앙침례교회 금요찬양기도집회] 올무가 끊어졌습니다 (시편 124편 1-8절) / 정성택 목사 / 2024.05.31. PM 8:00 #성령집회 #시편강해',
    videoId: 'IVQ85YWxPEY'
  },
  {
    date: '2024-05-24',
    title: '[얼바인중앙침례교회 금요찬양기도집회] 교회를 위해 복을 빌라 (시편 122편 1-9절) / 정성택 목사 / 2024.05.24. PM 8:00 #성령집회 #시편강해',
    videoId: 'EeNuowaRuEs'
  },
  {
    date: '2024-05-10',
    title: '[얼바인중앙침례교회 금요찬양기도집회] 험한 세상, 무엇을 바라보시겠습니까?  (시편 121편 1-8절) / 정성택 목사 / 2024.05.10. PM 8:00 #성령집회 #시편강해',
    videoId: '1gVJVnvfzcE'
  },
  {
    date: '2024-05-10',
    title: '[얼바인중앙침례교회  금요찬양기도집회] 화평을 위해 부르셨습니다  (시편 120편 1-7절) / 정성택 목사 / 2024.05.10. PM 8:00',
    videoId: 'kUV_DdrQ4d0'
  },
  {
    date: '2024-05-03',
    title: '[얼바인중앙침례교회  금요찬양기도집회] 말씀을 따라 행하는 자  (시편 119편 1-10절) / 정성택 목사 / 2024.05.3. PM 8:00',
    videoId: 'NU9-P72CvVk'
  },
  {
    date: '2024-04-19',
    title: '[얼바인중앙침례교회  금요찬양기도집회] 나는 하나님 편에 서 있는가?  (시편 118편 1-10절) / 정성택 목사 / 2024.04.19. PM 8:00',
    videoId: 'fCrAo7RNgRc'
  },
  {
    date: '2024-04-19',
    title: '[얼바인중앙침례교회  금요찬양기도집회] 주의 백성들아 하나님을 찬양하라 (시편 117편) / 정성택 목사 / 2024.04.19. PM 8:00',
    videoId: '8RalxMMc25o'
  },
  {
    date: '2024-04-12',
    title: '[얼바인중앙침례교회  금요찬양기도집회] 은혜를 받은 자 (시편 116편) / 정성택 목사 / 2024.04.12. PM 8:00',
    videoId: 'HHO3Cu4dPFE'
  },
  {
    date: '2024-04-05',
    title: '[얼바인중앙침례교회  금요찬양기도집회] 오직 주만 의지하십시오(시편 115편) / 정성택 목사 / 2024.04.05. PM 8:00',
    videoId: 'IXf3dQDW3XQ'
  },
  {
    date: '2024-03-29',
    title: '[얼바인중앙침례교회 고난주간 특별 금요기도집회] 십자가 (마태복음 27:26-54) / 정성택 목사 / 2024.03.29. PM 8:00',
    videoId: '7zxxtHTlZhc'
  },
  {
    date: '2024-03-22',
    title: '[얼바인중앙침례교회 금요성령기도회] 우리에게 일어난 기적 중의 기적 (시편 114편) / 정성택 목사 / 2024.03.22. PM 8:00',
    videoId: 'EDga1y77JdU'
  },
  {
    date: '2024-03-15',
    title: '[얼바인중앙침례교회 금요성령기도회] 우리 하나님 같은 이 없습니다 (시편 113) / 정성택 목사 / 2024.03.15. PM 8:00',
    videoId: 'LTWMbg9-BBw'
  },
  {
    date: '2024-03-01',
    title: '[얼바인중앙침례교회 금요성령기도회] 복 있는 자는 두려워하지 않습니다  (시편 112) / 정성택 목사 / 2024.03.01. PM 8:00',
    videoId: 'JshopEVcF3M'
  },
  {
    date: '2024-02-23',
    title: '[얼바인중앙침례교회 금요성령기도회] 지혜를 구하라  (시편 111) / 정성택 목사 / 2024.02.23. PM 8:00',
    videoId: 'mp5a0IxzbJE'
  },
  {
    date: '2024-02-16',
    title: '[얼바인중앙침례교회 금요성령기도회] 원수 앞에서 우리가 할 일  (시편 110) / 정성택 목사 / 2024.02.16. PM 8:00',
    videoId: '0DEuVI01QNc'
  },
  {
    date: '2024-02-09',
    title: '[얼바인중앙침례교회 금요성령기도회] 악인을 향한 저주의 기도 (시편 109) / 정성택 목사 / 2024.02.09. PM 8:00',
    videoId: '9SLO2YmAro8'
  },
  {
    date: '2024-01-26',
    title: '[얼바인중앙침례교회 금요성령기도회] 승리의 확신 (시편 108) / 정성택 목사 / 2024.01.26. PM 8:00',
    videoId: 'LvXMOPjyR4w'
  },
  {
    date: '2024-01-19',
    title: '[얼바인중앙침례교회 금요성령기도회] 구속함을 받은 자에게 일어난 변화 (시편 107:1-8) / 정성택 목사 / 2024.01.19. PM 8:00',
    videoId: '1K3MDQWclog'
  },
  {
    date: '2024-01-12',
    title: '[얼바인중앙침례교회 금요성령기도회] 하나님의 인자하심의 크기 (시편 106:1) / 정성택 목사 / 2024.01.12. PM 8:00',
    videoId: 'IxjpbVJ3U2M'
  },
  {
    date: '2024-01-05',
    title: '[얼바인중앙침례교회 금요성령기도회] 무엇을 자랑하시겠습니까?  (시편 105:3-7) / 정성택 목사 / 2024.01.05. PM 8:00',
    videoId: 'KnxHDw8vEGM'
  },
  {
    date: '2023-09-15',
    title: '[얼바인중앙침례교회 금요성령기도회] 자기 성도에게 화평을 말씀하실 것이라 / 시편 85:8 / 정성택 목사 / 2023.9.15 pm8:00',
    videoId: 'fxLqCPM4RmE'
  },
  {
    date: '2023-09-01',
    title: '[얼바인중앙침례교회 금요성령기도회] 마지막 재판장이신 하나님 (시편 82:8) / 정성택 목사 / 2023.9.1 pm 8:00',
    videoId: '6ysVd2gXLqc'
  },
  {
    date: '2023-08-25',
    title: '[얼바인중앙침례교회 금요 성령기도회] 수치로 채우소서 (시편 83:16) / 정성택 목사 / 2023.8.25 pm 8:00',
    videoId: 'AKhU-PLNZQQ'
  },
  {
    date: '2023-08-18',
    title: '[얼바인중앙침례교회 금요성령기도회] 네 입을 크게 열라 (시편 81:10) / 정성택 목사 / 2023.8.18 pm 8:00',
    videoId: 'ypKC6cXzM54'
  },
  {
    date: '2023-08-11',
    title: '[얼바인중앙침례교회 금요성령기도회] 부흥을 위한 기도 (시편 80편 18-19절) / 정성택 목사 / 2023.8.11 pm 8:00',
    videoId: 'Nm7fAv8BtZk'
  },
  {
    date: '2023-08-07',
    title: '[얼바인중앙침례교회 금요성령기도회] 인생의 밤을 맞을 준비를 하십시오 (시편 79편) / 정성택 목사 / 2023.8.7 pm 8:00',
    videoId: 'kbpXWs-p3i4'
  },
  {
    date: '2023-07-21',
    title: '[얼바인중앙침례교회 금요성령기도회] 분명하고 확실한 것 (시편 73) / 2023.7.21. pm 8:00',
    videoId: 'YC9l84u8EW0'
  },
  {
    date: '2023-07-07',
    title: '[강중침 & 얼중침 연합 금요성령기도회] 2023.7.7. pm 9:00',
    videoId: '65MXT9ehLAk'
  },
  {
    date: '2023-03-31',
    title: '[IJBC]얼바인중앙침례교회 금요찬양기도집회 2023.3.31. pm8:00',
    videoId: 'UzwTEKw1RQk'
  },
  {
    date: '2023-03-10',
    title: '[IJBC 금요찬양기도집회] / 어떻게 기다려야 할까요? / 시편 40편 / 정성택 목사 / 2023.3.10',
    videoId: 'n0Mb01032RY'
  },
  {
    date: '2023-03-03',
    title: '[IJBC 금요찬양기도집회] / 허무한 인생 속에서의 기도/ 시편 39편 / 정성택 목사 / 2023.3.3.',
    videoId: 'GAdKwlOOxpw'
  },
  {
    date: '2023-02-24',
    title: '[IJBC 금요찬양기도집회] / 연약한 자의 선한 소원/ 시편 38편 / 정성택 목사 / 2023.2.24',
    videoId: '3bGRoQak-2E'
  },
  {
    date: '2023-02-17',
    title: '[IJBC 금요찬양기도집회] / 주의 판단은 큰 바다와 같습니다./ 시편 36편 / 정성택 목사 / 2023.2.17',
    videoId: 'MWYfqt62EXc'
  },
  {
    date: '2023-02-10',
    title: '[IJBC 금요찬양기도회] 얼바인중앙침례교회 금요찬양기도회 2023.2.10 pm 8:00',
    videoId: '9nOTZFBbquw'
  },
  {
    date: '2023-02-03',
    title: '[IJBC 금요찬양기도집회] / 은혜를 구하는 기도 / 시편 34편 / 정성택 목사 / 2023.2.3',
    videoId: 'H6KF4oTQBEA'
  },
  {
    date: '2023-01-27',
    title: '[IJBC 금요찬양기도집회] / 너는 여호와를 바라고 바랄찌어다 / 시편 27편 14절 / 정성택 목사 / 2023.1.27',
    videoId: 'Bejsk_usuzs'
  },
  {
    date: '2023-01-20',
    title: '[IJBC 금요찬양기도집회] / 하늘의 신령한 복, 찬양입니다. / 시편33편 / 정성택 목사 / 2023.1.20',
    videoId: 'yCvDg91GPqU'
  },
  {
    date: '2023-01-13',
    title: '[IJBC 금요찬양기도집회] / 누가 복있는 자 인가? / 시편32편 / 정성택 목사 / 2023.1.13',
    videoId: '8w170AsdBTk'
  },
  {
    date: '2022-12-23',
    title: '[IJBC 금요찬양기도집회]  / 성도의 찬양 / 시편 30편 / 정성택 목사 / 2022.12.23',
    videoId: '_eieg4_d0A8'
  },
  {
    date: '2022-12-16',
    title: '[IJBC] 금요찬양기도집회 2022.12.16 pm 8:00',
    videoId: 'ISS9dl1aYJc'
  },
  {
    date: '2022-12-09',
    title: '[IJBC] 금요찬양기도집회 영광의 왕이 누구이시냐 / 시편 24편 / 2022.12.9 pm 8:00',
    videoId: '-3etNyrbXeQ'
  },
  {
    date: '2022-10-28',
    title: '[IJBC] 얼바인중앙침례교회 금요찬양기도회 2022.10.28. 8:00PM',
    videoId: 'UJc3a1GsIDA'
  },
  {
    date: '2022-10-21',
    title: '[IJBC] 얼바인중앙침례교회 금요찬양기도회 2022.10.21. 8:00PM',
    videoId: 'Pblu3ubG5to'
  },
  {
    date: '2022-10-14',
    title: '[IJBC금요찬양기도집회] 시편강해 - 시편 8편 자기 영광을 나타내어주시는 하나님 / 정성택 담임 목사 / 2022.10.14',
    videoId: 'Vxua6lTm70w'
  },
  {
    date: '2022-10-07',
    title: '[IJBC금요찬양기도집회] 시편강해 - 시편 3편 주의 복을 주의 백성에게 내리소서 / 정성택 담임 목사 / 2022.10.07',
    videoId: 'D8wmHMIttxo'
  },
  {
    date: '2022-09-30',
    title: '[IJBC금요찬양기도집회] 시편강해 - 시편 5편 주의 이름을 사랑하는 자에게 주시는 영원한 기쁨 / 정성택 담임 목사 / 2022.09.30',
    videoId: 'rTU2yslYgW8'
  },
  {
    date: '2022-09-23',
    title: '[IJBC] 얼바인중앙침례교회 금요찬양기도회 2022.09.23',
    videoId: '34Wnkn3T_zw'
  },
  {
    date: '2022-09-16',
    title: '[IJBC] 얼바인중앙침례교회 금요찬양기도회 2022.09.16.',
    videoId: '4QE7lVc8dtA'
  },
  {
    date: '2022-09-09',
    title: '[IJBC] 얼바인중앙침례교회 금요찬양기도회 2022.09.09',
    videoId: 'aYvXE7BCKRg'
  },
  {
    date: '2022-09-02',
    title: '[IJBC] 얼바인중앙침례교회 금요찬양기도회 2022.09.02 8:00PM',
    videoId: 'xbjUKML1Ryw'
  },
  {
    date: '2022-08-26',
    title: '[IJBC] 얼바인중앙침례교회 금요찬양기도회 2022.08.26. 8:00PM',
    videoId: 'zEOrHPqqPhA'
  },
  {
    date: '2022-08-19',
    title: '[IJBC] 얼바인중앙침례교회 금요찬양기도회 2022.08.19 8:00PM',
    videoId: 'F-u_AmsyxM0'
  },
  {
    date: '2022-08-12',
    title: '[IJBC] 금요 찬양 기도회 2022.08.12 8:00PM',
    videoId: 'OxR_RFuYQhI'
  },
  {
    date: '2022-08-05',
    title: '[IJBC] 얼바인중앙침례교회 금요 찬양 기도회 2022.08.05 8:00PM',
    videoId: 'ZBRezrtSQpE'
  },
  {
    date: '2022-07-29',
    title: '[IJBC] 얼바인중앙침례교회 금요찬양기도회 2022.7.29 8:00PM',
    videoId: 'XcwpMcO-7oc'
  },
  {
    date: '2022-07-22',
    title: '[IJBC] 얼바인중앙침례교회 금요 찬양 기도회 2022.07.22 08:00 PM',
    videoId: 'lJ6nbFNdtWk'
  },
  {
    date: '2022-07-15',
    title: '[IJBC] 얼바인중앙침례교회 금요찬양기도회 2022.07.15 8pm',
    videoId: 'IRTTxGXeG2s'
  },
  {
    date: '2022-07-08',
    title: '[IJBC] 얼바인중앙침례교회 금요찬양기도회 2022.07.08 8:00 PM',
    videoId: '4gvvT-eDnBo'
  },
  {
    date: '2022-07-01',
    title: '[IJBC] 얼바인중앙침례교회 금요찬양기도회 2022.07.01 8PM',
    videoId: 'CVISe1J8XPk'
  },
  {
    date: '2022-06-17',
    title: '[IJBC] 얼바인중앙침례교회 금요 기도 집회 2022.6.17 8PM',
    videoId: 'ePULNAHu2QI'
  },
  {
    date: '2022-06-10',
    title: '[IJBC] 얼바인중앙침례교회 금요기도집회 2022.6.10 8:00PM',
    videoId: 'UZ5sglb730o'
  },
  {
    date: '2022-06-03',
    title: '[IJBC] 금요기도집회 2022.06.03. 8:00PM',
    videoId: 'nYYHhU8uLc0'
  },
  {
    date: '2022-05-27',
    title: '[IJBC] 얼바인중앙침례교회 2022.5.27 금요기도집회',
    videoId: '2MCaqaxXaog'
  },
  {
    date: '2022-05-20',
    title: '[IJBC] 얼바인중앙침례교회 2022.05.20  금요기도집회',
    videoId: 'n698UkCpM7k'
  },
  {
    date: '2022-05-13',
    title: '[IJBC] 얼바인중앙침례교회  2022.5.13 금요기도집회',
    videoId: 'bfZsi-WJ37g'
  },
  {
    date: '2022-05-06',
    title: '[IJBC] 얼바인중앙침례교회 2022.05.06 금요기도집회',
    videoId: 'uPH1rG1U6nE'
  },
  {
    date: '2022-04-29',
    title: '[IJBC] 얼바인중앙침례교회 2022.04.29 금요기도집회',
    videoId: 'v4W4Z4hnTxk'
  },
  {
    date: '2022-04-22',
    title: '[IJBC] 얼바인중앙침례교회 2022.04.22 금요기도집회',
    videoId: 'a5BzIJdylUE'
  },
  {
    date: '2022-04-15',
    title: '[IJBC] 얼바인중앙침례교회 2022.04.15 금요기도집회 / 고난주간 "보혈"',
    videoId: 'myU95QaU2vA'
  },
  {
    date: '2022-04-08',
    title: '[IJBC] 얼바인중앙침례교회  2022.4.08 금요기도집회',
    videoId: 'XpcMyOUDTeI'
  },
  {
    date: '2022-04-01',
    title: '[IJBC] 얼바인중앙침례교회  2022.4.01 금요기도집회',
    videoId: 'fGIjG4VMVHM'
  },
  {
    date: '2022-03-25',
    title: '[IJBC] 얼바인중앙침례교회 2022.03.25  금요기도집회',
    videoId: 'eWwBrYUXeHY'
  },
  {
    date: '2022-03-18',
    title: '[IJBC] 얼바인중앙침례교회 2022.03.18 금요기도집회',
    videoId: 'ODpwJK3WvDg'
  },
  {
    date: '2022-03-11',
    title: '[IJBC] 얼바인중앙침례교회  2022.3.11 금요기도집회',
    videoId: 'JWrsOD1vjZM'
  },
  {
    date: '2022-03-04',
    title: '[IJBC] 얼바인중앙침례교회 2022.03.04 금요기도집회',
    videoId: 'FVPwuXT3uoI'
  },
  {
    date: '2022-02-25',
    title: '[IJBC] 얼바인중앙침례교회  2022.2.25 금요기도집회',
    videoId: 'nNcfndU_kNM'
  },
  {
    date: '2022-02-18',
    title: '[IJBC] 얼바인중앙침례교회  2022.2.18 금요기도집회',
    videoId: 'j5dP5sGgd48'
  },
  {
    date: '2022-02-11',
    title: '[IJBC] 얼바인중앙침례교회  2022.2.11 금요기도집회 / 한나의 기도',
    videoId: 'J74O6K7t-wo'
  },
  {
    date: '2022-02-04',
    title: '[IJBC] 얼바인중앙침례교회  2022.2.04 금요기도집회 / 동굴속에서의 기도',
    videoId: 'WLVKRKv3Ae8'
  },
  {
    date: '2022-01-28',
    title: '[IJBC] 얼바인중앙침례교회  2022.1.28. 금요기도집회 / 은혜의 보좌로 나아가라',
    videoId: 'asB5p1Y-yQ4'
  },
  {
    date: '2022-01-21',
    title: '[IJBC] 얼바인중앙침례교회  2022.1.21. 금요기도집회 / 왕의 보좌로 나아가라',
    videoId: 'Gn3z6pG57_Y'
  },
  {
    date: '2022-01-14',
    title: '[IJBC] 얼바인중앙침례교회  2022.1.14. 금요기도집회 / 기도에 대한 주님의 보증',
    videoId: 'L8_OiWU19Yo'
  },
  {
    date: '2022-01-07',
    title: 'IJBC 금요기도집회 / 2022.1.7. / 하나님께 부르짖는 이유',
    videoId: 'JrXhd4NH6DI'
  },
  {
    date: '2021-12-24',
    title: 'IJBC 금요기도집회 / 2021.12.24',
    videoId: '2rak5RZU8S4'
  },
  {
    date: 'Unknown Date',
    title: '[얼바인중앙침례교회 금요성령기도회 설교] 주님 뜻에 무릎을 꿇는 기도 (사무엘하 7장 18-21, 28-29절) / 2025.6. 27 pm 8:00',
    videoId: 'PbN6yfCaIpk'
  },
  {
    date: 'Unknown Date',
    title: '[IJBC 금요성령기도회 설교] 두려움 대신 기도를 선택 (사무엘상 7장 5-13절) / 2025.6. 20 pm 8:00',
    videoId: 'YWb99n_1wdU'
  },
  {
    date: 'Unknown Date',
    title: '[얼바인중앙침례교회 금요찬양기도집회] 하나님의 안식처 (시편 132편 13-18절) / 정성택 목사 / 2024.08. 16. PM 8:00 #성령집회 #시편강해',
    videoId: 'XU9USknWKVo'
  },
  {
    date: 'Unknown Date',
    title: '[얼바인중앙침례교회 금요찬양기도집회]  비전과 교만 (시편 131편 1-3절) / 정성택 목사 / 2024.08. 9. PM 8:00 #성령집회 #시편강해',
    videoId: 'nYd4bROUw50'
  },
  {
    date: 'Unknown Date',
    title: '[얼바인중앙침례교회 금요성령특별회] 부흥과 기도 (사도행전 1:12-14) / 피영민 목사',
    videoId: '0eFtGn4G6mU'
  },
  {
    date: 'Unknown Date',
    title: '[얼바인중앙침례교회 금요성령기도회] 일을 행하시는 여호와  (시편 104:31) / 정성택 목사 / 시편강해',
    videoId: 'xNmBYVDzOko'
  },
  {
    date: 'Unknown Date',
    title: '[얼바인중앙침례교회 금요성령기도회] 내 영혼아 여호와를 전심으로 찬양하라 (시편 103:1-5) / 정성택 목사 / 시편강해',
    videoId: 'g3_T2t0q_TQ'
  },
  {
    date: 'Unknown Date',
    title: '[IJBC 금요성령기도회]  회복을 기다리는 자 (시편 102:17-22) / 정성택 목사 / 2023_12_15 08:00PM',
    videoId: 'LSZMZROFVSI'
  },
  {
    date: 'Unknown Date',
    title: '[IJBC 금요성령기도회]  하나님께 쓰임을 받는 자  (시편 101:1-8) / 정성택 목사 / 2023_12_08 08:00PM',
    videoId: '8WqRLpr4YFc'
  },
  {
    date: 'Unknown Date',
    title: '[IJBC 금요성령기도회]  하나님을 사랑하는 자여 (시편 97:10) / 정성택 목사 / 2023_12_01 08:00PM',
    videoId: 'xVfevAfGU7Y'
  },
  {
    date: 'Unknown Date',
    title: '[IJBC 금요성령기도회] 오라 여호와께 경배하자(시편 95편) / 정성택 목사 / 2023_11_24 08:00PM',
    videoId: '2S4GaxxNy60'
  },
  {
    date: 'Unknown Date',
    title: '[IJBC 금요성령기도회] 하나님의 위로 (시편 94편) / 정성택 목사 / 2023_11_17 08:00PM',
    videoId: 'Usb3tx2FODI'
  },
  {
    date: 'Unknown Date',
    title: '[IJBC 금요성령기도회] 여호와께서 통치하시니 (시편93:1-5) / 2023_11_10 08:00PM',
    videoId: 'V4xTft-ZoC0'
  },
  {
    date: 'Unknown Date',
    title: '[IJBC 금요성령기도회] 주께서 우리의 기쁨을 위해 일하시는 것을 아십니까?/시편 92:1-6 / 정성택 목사 #시편강해 #얼바인 #교회 #개혁주의  #광야 #인생 #피난처',
    videoId: 'DltirTo6cTo'
  },
  {
    date: 'Unknown Date',
    title: '[IJBC 금요성령기도회] 오직 하나님이 나의 피난처 되십니다. /시편 91:1-3 / 정성택 목사 #시편강해 #얼바인 #교회 #개혁주의  #광야 #인생 #피난처',
    videoId: 'hr7sgM8px_Q'
  },
  {
    date: 'Unknown Date',
    title: '[얼바인중앙침례교회 금요성령기도회]  광야속에서 만족을 주시옵소서 / 시편 90:14 / 정성택 목사 #시편강해  #얼바인 #교회 #개혁주의  #광야 #모세의 기도',
    videoId: 'PQWiu8sYzbU'
  },
  {
    date: 'Unknown Date',
    title: '[얼바인중앙침례교회 금요성령기도회]  언약을 믿고 찬양하라 /시편 89편 1-4절 / 정성택 목사 #얼바인 #개혁주의 #시편강해 #찬양 #한인교회',
    videoId: 'x0LXS_9Flf8'
  },
  {
    date: 'Unknown Date',
    title: '[얼바인중앙침례교회 금요성령기도회] 고통 속에 있는 성도는... /시편 88편 1-7절 / 정성택 목사 #얼바인 #개혁주의 #시편강해 #고통 #한인교회',
    videoId: 'HgbwDOw_3zg'
  },
  {
    date: 'Unknown Date',
    title: '[I얼바인중앙침례교회 금요성령기도회] 시온성과 같은 교회 /시편 87편 / 정성택 목사 #교회 #개혁주의 #시편강해 #얼바인',
    videoId: '_VVZFOTy_8A'
  },
  {
    date: 'Unknown Date',
    title: '[얼바인중앙침례교회 금요성령기도회] 내게 주의 도를 가르쳐 주시옵소서 / 시편 86편 1-7,11 / 정성택 목사 # 시편강해 # 개혁주의 #얼바인',
    videoId: '815KR6QnoAs'
  },
  {
    date: 'Unknown Date',
    title: '[얼바인중앙침례교회 금요성령기도회] 주의 제단에서 보금자리를 얻었나이다 / 시편 84:1-3 / 정성택 목사 #개혁주의  #시편강해 #얼바인',
    videoId: 'EepKYk4xSbY'
  },
  {
    date: 'Unknown Date',
    title: '[얼바인중앙침례교회 금요성령기도회] 낙심중에 있을 때에 (시편 77편) / 정성택 목사  #개혁주의  #시편강해 #얼바인',
    videoId: 'm2KlKFfJmos'
  },
  {
    date: 'Unknown Date',
    title: '[얼바인중앙침례교회 금요성령기도집회] 오직 주님만이 나의 반석입니다 / 시편 62:1-2.5-6절 / 정성택 목사',
    videoId: 'ewlrtQVmswQ'
  },
  {
    date: 'Unknown Date',
    title: '[얼바인중앙침례교회 금요성령기도집회]  나를 높은 바위 위로 인도하소서 / 시편 61편 / 정성택 목사',
    videoId: 'A07IobtKB9k'
  },
  {
    date: 'Unknown Date',
    title: '[얼바인중앙침례교회 금요성령기도집회]  슬픔을 감사로 바꾸는 비결 / 시편 57편 / 정성택 목사',
    videoId: 'NOu1ukPATcY'
  },
  {
    date: 'Unknown Date',
    title: '[얼바인중앙침례교회 금요기도집회]  황금률 / 시편 56편 / 정성택 목사',
    videoId: 'dIR-dP22l3k'
  },
  {
    date: 'Unknown Date',
    title: '[얼바인중앙침례교회 금요기도집회]  성도의 소명 / 시편 51편 / 정성택 목사',
    videoId: 'ibx92zm8Jps'
  },
  {
    date: 'Unknown Date',
    title: '[얼바인중앙침례교회 금요기도집회]  어떻게 하는 것이 여호와께 짐을 맡겨드리는 건가요? / 시편 55편 / 정성택 목사',
    videoId: '9G6huyFl20k'
  },
  {
    date: 'Unknown Date',
    title: '[얼바인중앙침례교회 금요기도집회]  하나님의 인자하심이 나의 것입니다. / 시편 59편 / 정성택 목사',
    videoId: 'dIMCFmW74_Y'
  },
  {
    date: 'Unknown Date',
    title: '[얼바인중앙침례교회 금요기도집회]  하나님의 약속 / 시편 50편 / 정성택 목사',
    videoId: 'rs2DDEbzAqk'
  },
  {
    date: 'Unknown Date',
    title: '[얼바인중앙침례교회 금요기도집회]  우리는 들은 대로 볼 것입니다. / 시편 48편 / 정성택 목사',
    videoId: 'n5wUfd-sYQw'
  },
  {
    date: 'Unknown Date',
    title: '[IJBC]얼바인주앙침례교회 고난주간 금요기도회 2023. 4.7. pm 8:00',
    videoId: 'cpt08YoOpCc'
  },
  {
    date: 'Unknown Date',
    title: '[IJBC 금요찬양기도집회] / 갈급한 심령의 이유 / 시편 42편 / 정성택 목사 / 2023. 3.24.',
    videoId: 'XE7AjvT_oak'
  },
  {
    date: 'Unknown Date',
    title: '[IJBC 금요찬양기도집회] / 가장 가치가 있는 말 / 시편 41편 / 정성택 목사 / 2023. 3.17.',
    videoId: '0-vQO5COdGs'
  },
  {
    date: 'Unknown Date',
    title: '[IJBC 금요찬양기도집회]  쌓아두신 은혜, 베푸신 은혜  / 시편 31편 / 정성택 목사',
    videoId: 'BGM5_ubjNSI'
  },
  {
    date: 'Unknown Date',
    title: '[IJBC] 얼바인중앙침례교회 금요찬양기도집회 2022-11-25',
    videoId: 'CAJ3kS-HfG8'
  },
  {
    date: 'Unknown Date',
    title: '[IJBC] 얼바인중앙침례교회 금요찬양기도집회 2022-11-18',
    videoId: 'FON2vyCFn6s'
  },
  {
    date: 'Unknown Date',
    title: '[IJBC] 얼바인중앙침례교회 금요찬양기도집회 2022-11-11',
    videoId: 'cDMBILuP17k'
  },
  {
    date: 'Unknown Date',
    title: '[IJBC] 얼바인중앙침례교회 금요찬양기도집회 2022-11-04 8PM',
    videoId: 'TBHHDqEXDgw'
  },
];
